import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const CbseDisclosure = () => {
      useEffect(() => {
        document.title = 'CBSE Disclosure -   Mary Matha Cmi  Academy';  
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li>  
     <li> CBSE Mandatory Disclosure </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1> CBSE Mandatory Disclosure  </h1>
         </div>
     </div>
     <div className="row">
     <div class="col-lg-12"><h6>A: GENERAL INFORMATION</h6><div class="table-responsive maintable"><table class="table"><thead>
     <tr>
     <th width="10%" class="text-center">S.NO</th><th width="60%" class="text-center">INFORMATION</th><th width="30%" class="text-center">DETAILS</th></tr>
   </thead><tbody>
     <tr>
     <td>1 </td>
     <td>NAME OF THE SCHOOL </td>
   <td> Mary Matha Cmi  Academy , Devadanapatti </td>
   </tr>
   
   <tr>
     <td>2 </td>
     <td>AFFILIATION NO.(IF APPLICABLE) </td>
   <td>-</td>
   </tr>
   
   <tr>
     <td>3 </td>
     <td>SCHOOL CODE (IF APPLICABLE) </td>
   <td>-</td>
   </tr>
   
   <tr>
     <td>4 </td>
     <td>COMPLETE ADDRESS WITH PIN CODE</td>
   <td> D.No. 224/B, Perumalkoilpatti, Devadanapatti, Periyakulam Taluk, Theni – 625602, Tamilnadu.
   </td>
   </tr>
   
   <tr>
     <td>5</td>
     <td> PRINCIPAL NAME &amp; QUALIFICATION: </td>
   <td>-</td>
   </tr>
   
   <tr>
     <td>6</td>
     <td> SCHOOL EMAIL ID</td>
   <td><a href="mail:mmcmiacademy@gmail.com">mmcmiacademy@gmail.com</a></td>
   </tr>
   
   <tr>
     <td>7 </td>
     <td>CONTACT DETAILS (LANDLINE/MOBILE)</td>
   <td><a href="tel:+91 8056851655">+91 8056851655</a></td>
   </tr>
   </tbody></table></div><h6>B: DOCUMENTS AND INFORMATION</h6><div class="table-responsive maintable"><table class="table"><thead>
     <tr>
     <th width="10%" class="text-center">S.NO </th><th width="60%" class="text-center">DOCUMENTS/INFORMATION </th><th width="30%" class="text-center">UPLOAD DOCUMENTS</th></tr>
   </thead><tbody>
   <tr>
   <td>1 </td>
   <td>Mandatory Public Disclosure   | SARAS 5.0 </td>
 <td><a href="#" target="_blank">View</a></td>
 </tr>
     <tr>
     <td>2 </td>
     <td>COPIES OF AFFILIATION/UPGRADATION LETTER AND RECENT EXTENSION OF AFFILIATION, IF ANY </td>
   <td><a href="#" target="_blank">View</a></td>
   </tr>
   
   <tr>
     <td>3 </td>
     <td>COPIES OF SOCIETIES/TRUST/COMPANY REGISTRATION/RENEWAL CERTIFICATE </td>
   <td><a href="#" target="_blank">View </a></td>
   </tr>
   
   <tr>
     <td>4 </td>
     <td>COPY OF NO OBJECTION CETIFICATE (NOC) ISSUED </td>
     <td><a href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/pdf/noc.pdf" target="_blank">View </a></td>
   </tr>
   
   <tr>
     <td>5 </td>
     <td>COPIES OF RECOGNITION CERTIFICATE UNDER RTE ACT, AND ITS RENEWAL, IF APPLICABLE</td>
     <td><a href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/pdf/RECOGNITION.pdf" target="_blank">View </a></td>
   </tr>
   
   <tr>
     <td>6 </td>
     <td>COPY OF VALID  BUILDING CERTIFICATE </td>
   <td><a href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/pdf/BUILDING.pdf" target="_blank">View</a></td>
   </tr>
   
   <tr>
     <td>7 </td>
     <td>COPY OF VALID FIRE SAFETY CERTIFICATE </td>
   <td><a href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/pdf/FIRESAFETY.pdf" target="_blank">View</a></td>
   </tr>
   <tr>
   <td>8 </td>
   <td> COPIES oF DEO CERTIFICATES</td>
 <td><a href="#" target="_blank">View</a></td>
 </tr> 
   
   <tr>
     <td>9 </td>
     <td>COPIES OF VALID WATER, HEALTH AND SANITATION CERTIFICATES</td>
   <td><a href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/pdf/SANITATION.pdf" target="_blank">View</a></td>
   </tr> 
     <tr>
     <td>10</td>
     <td>COPY OF VALID  SELF CERTIFICATION </td>
   <td><a href="#" target="_blank">View</a></td>
   </tr>
   </tbody></table></div><h6>C: RESULT AND ACADEMICS</h6><div class="table-responsive maintable"><table class="table"><thead>
     <tr>
     <th width="10%" class="text-center">S.NO. </th><th width="60%" class="text-center">S.NO. DOCUMENTS/INFORMATION </th><th width="30%" class="text-center">UPLOAD DOCUMENTS</th></tr>
   </thead><tbody>
     <tr>
     <td>1 </td>
     <td>FEE STRUCTURE OF THE SCHOOL</td>
   <td><a href="#" target="_blank">View </a></td>
   </tr>
   
   <tr>
     <td>2 </td>
     <td>ANNUAL ACADEMIC CALENDER</td>
   <td><a href="#" target="_blank">View</a></td>
   </tr>
   
   <tr>
     <td>3 </td>
     <td>LIST OF SCHOOL MANAGEMENT COMMITTEE</td>
   <td><a href="#" target="_blank">View</a></td>
   </tr>
   
   <tr>
     <td>4 </td>
     <td>LIST OF PTA MEMBERS</td>
   <td><a href="#" target="_blank">View</a></td>
   </tr>
   
   <tr>
     <td>5 </td>
     <td>LAST THREE YEAR RESULT OF THE BOARD EXAMINATION</td>
   <td><a href="#" target="_blank">View</a></td>
   </tr>
   </tbody></table></div>  <h6>D: STAFF (TEACHING)</h6><div class="table-responsive maintable"><table class="table"><thead>
     <tr>
     <th width="10%" class="text-center">S.NO. </th><th width="60%" class="text-center">INFORMATION </th><th width="30%" class="text-center">DETAILS</th></tr>
   </thead><tbody>
     <tr>
     <td>1</td>
     <td>PRINCIPAL</td>
   <td> 1</td>
   </tr>
   
   <tr>
     <td>2</td>
     <td>TOTAL NO. OF TEACHERS</td>
   <td>-</td>
   </tr>
    
   
   <tr>
     <td rowspan="3"></td>
     <td> PGT</td>
     <td>-</td>
   </tr>
   
   <tr>
     <td> TGT </td>
     <td>-</td>
   </tr>

   <tr>
     <td> PRT </td>
     <td>-</td>
   </tr>
 
   <tr>
     <td>3 </td>
     <td>TEACHERS SECTION RATIO </td>
   <td>-</td>
   </tr>
   
   <tr>
     <td>4 </td>
     <td>DETAILS OF SPECIAL EDUCATOR </td>
   <td>-</td>
   </tr>
   
   <tr>
     <td>5 </td>
     <td> DETAILS OF COUNSELLOR AND WELLNESS TEACHER </td>
   <td> - </td>
   </tr>
   </tbody></table></div><h6>E: SCHOOL INFRASTRUCTURE</h6><div class="table-responsive maintable"><table class="table"><thead>
     <tr>
     <th width="10%" class="text-center">S.NO. </th><th width="60%" class="text-center">INFORMATION </th><th width="30%" class="text-center">DETAILS</th></tr>
   </thead><tbody>
     <tr>
     <td>1</td>
     <td>TOTAL CAMPUS AREA OF THE SCHOOL (IN SQUARE MTR) </td>
   <td>-</td>
   </tr>
   
   <tr>
     <td>2</td>
     <td> NO. AND SIZE OF THE CLASS ROOMS (IN SQUARE MTR)</td>
   <td>-</td>
   </tr>
   
   <tr>
     <td>3</td>
     <td> NO.ANDSIZEOFLABORATORIESINCLUDING COMPUTER LABS (IN SQ MTR)</td>
   <td>-</td>
   </tr>
   
   <tr>
     <td>4 </td>
     <td>INTERNET FACILITY</td>
   <td> -</td>
   </tr>
   
   <tr>
     <td>5</td>
     <td> NO. OF GIRLS TOILETS</td>
   <td>-</td>
   </tr>
   
   <tr>
     <td>6</td>
     <td> NO. OF BOYS TOILETS</td>
   <td>-</td>
   </tr>
   
   <tr>
     <td>7</td>
     <td>LINK OF YOUTUBE VIDEO OF THE INSPECTION OF SCHOOL COVERING THE INFRASTRUCTURE OF THE SCHOOL</td>
   <td><a href="#" target="_blank"><b> - </b></a></td>
   </tr>
   </tbody></table></div></div>
    </div>
</div>
</div>
<Footer/>
    </>
  )
}

export default CbseDisclosure
